import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import { MetaTagsComp } from '../components/MetaTagsComp';
import fetchUtil from '../utils/fetchUtil';
import styles from '../styles/Header.module.scss'

const PaymentTerms: NextPage = (props: any) => {
  const { meta } = props.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#226CF5');
    customStyle.setProperty('--navbar-menu-color', '#ffffff')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <div className={styles.termsClass} dangerouslySetInnerHTML={{ __html: props.pageData.description }}></div>
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/payment-terms`, 'GET', {}, '', false)
  return {
    props: {
      pageData,
    }
  };
}

export default PaymentTerms;